import mainCaller from './mainCaller';

// 만료일연장 내역 (단건 만료수정 + 일괄 연장/축소)
export const getExpireUpdateHistory = async (query, token) => {
  return await mainCaller(`admin/api/v1/member-course-history/expire-update?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// 상품중지 내역 (중지 / 중지해제)
export const getStopHistory = async (query, token) => {
  return await mainCaller(`admin/api/v1/member-course-history/stop?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// 정보수정 이력 취소(롤백) — 변경 전 값으로 되돌림. category: TICKET | PASS
export const cancelExpireUpdateHistory = async (historyId, category, token) => {
  return await mainCaller(
    `admin/api/v1/member-course-history/expire-update/${historyId}/cancel?category=${category}`,
    'POST',
    null,
    {
      Authorization: `Bearer ${token}`,
    }
  );
};
